import { PropsWithChildren } from 'react';

import { LoadingScreenSamFull } from '../components/LoadingScreen/LoadingScreenSamFull.js';
import { useGetAccount } from '../hooks/api/toolkitComponents.js';
import { FTUXContext } from './consts.js';

export const FTUXContextProvider = ({ children }: PropsWithChildren) => {
  const getAccount = useGetAccount({});

  if (getAccount.isLoading) {
    return <LoadingScreenSamFull isLoading />;
  }

  if (getAccount.isError) {
    throw new Error('Account loading error for FTUX context');
  }

  return <FTUXContext.Provider value={{}}>{children}</FTUXContext.Provider>;
};
